export enum DividerTypes {
  STANDARD_DIVIDER = 'standard_divider',
  ACCENT_DIVIDER = 'accent_divider',
}

export enum DividerColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}
